module.exports = __webpack_public_path__ + "static/media/hour.ea85ab17.svg";